// ============================================================================
// Notifiche di piattaforma (aggregate, mock) — campanella globale in Topbar.
// Deriva notifiche rilevanti per l'utente: nuovo cliente assegnato, nuovo
// documento nella propria area HR, campagne bloccate/non approvate, esito
// approvazione modifiche del cliente (proposte), note condivise.
// NON include le task mensili (troppo rumorose).
// ============================================================================

import { CLIENTS } from "@/data/mockData";
import { getProposals } from "@/lib/administrationData";
import { getRegistryClient } from "@/lib/clientRegistry";
import { getSharedWithUser } from "@/lib/notesData";
import { listNotifications as hrList } from "@/lib/hrData";

const READ_KEY = "aesthetic-os-platform-notif-read";
const BLOCKING_ALERTS = {
  ad_account_disabled: "Account pubblicitario disabilitato",
  ad_rejected: "Inserzione rifiutata",
  not_delivering: "Campagna non in erogazione",
};

const readSet = () => { try { return new Set(JSON.parse(localStorage.getItem(READ_KEY) || "[]")); } catch { return new Set(); } };
const writeSet = (s) => localStorage.setItem(READ_KEY, JSON.stringify([...s]));

export const platformNotifications = (user) => {
  if (!user || user.role === "client_user") return [];
  const isAdmin = user.role === "admin";
  const myClients = isAdmin ? CLIENTS : CLIENTS.filter((c) => c.manager === user.id);
  const read = readSet();
  const out = [];
  const push = (id, type, title, body, tone, link) => out.push({ id, type, title, body, tone, link, read: read.has(id) });

  // Nuovo cliente assegnato
  myClients.forEach((c) => push(`client_${c.id}`, "client", "Cliente assegnato", `Ti è stato assegnato ${c.name}`, "info", `/clienti/${c.id}`));

  // Campagne bloccate / non approvate
  myClients.forEach((c) => (c.alerts || []).forEach((code) => {
    if (BLOCKING_ALERTS[code]) push(`alert_${c.id}_${code}`, "campaign", "Campagna bloccata", `${c.name}: ${BLOCKING_ALERTS[code]}`, "error", `/clienti/${c.id}`);
  }));

  // Esito approvazione modifiche del cliente (proposte accettate/rifiutate)
  getProposals().filter((p) => ["accepted", "rejected"].includes(p.status)).forEach((p) => {
    const cn = getRegistryClient(p.client_id)?.client_name || "Cliente";
    const ok = p.status === "accepted";
    push(`prop_${p.id}_${p.status}`, "proposal", ok ? "Modifica approvata" : "Modifica non approvata", `${cn} ${ok ? "ha approvato" : "non ha approvato"}: ${p.title || "proposta"}`, ok ? "ok" : "warning", "/amministrazione");
  });

  // Note condivise con me
  getSharedWithUser(user.id).forEach((it) => push(`note_${it.id}`, "note", "Nota condivisa", `Ti è stata condivisa: ${it.title || "una nota"}`, "info", "/appunti"));

  // Documenti caricati nella mia area HR
  hrList({ audience: "employee", employeeId: user.id }).filter((n) => n.type === "document").forEach((n) => push(`hr_${n.id}`, "document", "Nuovo documento HR", n.body || n.title, "info", "/hr"));

  return out;
};

export const platformUnread = (user) => platformNotifications(user).filter((n) => !n.read).length;
export const markPlatformRead = (id) => { const s = readSet(); s.add(id); writeSet(s); };
export const markAllPlatformRead = (user) => { const s = readSet(); platformNotifications(user).forEach((n) => s.add(n.id)); writeSet(s); };
